import React, { lazy, Suspense } from "react";
import { Redirect } from "react-router-dom";
import { isStaffManagementPreviewEnabled } from "./preview-enabled";

// Compile-time guard keeps the provider and all fixtures out of production chunks.
const PreviewPage = process.env.NODE_ENV === "development" && process.env.REACT_APP_STAFF_MANAGEMENT_PREVIEW === "true" ?
    lazy(() => import("./staff-management-preview-page")) : null;

const StaffManagementPreviewRoute = ({ screen }) => {
    if (!isStaffManagementPreviewEnabled() || !PreviewPage) return <Redirect to="/more" />;
    return <Suspense fallback={null}><PreviewPage screen={screen} /></Suspense>;
};

export default StaffManagementPreviewRoute;
